(function () {
    $('.js-m-input-clear-btn').on('click', function (event) {
        event.preventDefault();

        $('.m-input-clear input:checkbox').each(function () {
            this.checked = false;
        });
    })
})();
